import { ArdoqLoaderComponent, LoaderColor, LoaderSize } from '@ardoq/loader';
import { EmptyState, EmptyStateNoResultIllustration } from '@ardoq/status-ui';
import { TableEmptyStateLabels } from './labels';

export const renderTableEmptyState = (labels: TableEmptyStateLabels) => (
  <EmptyState
    title={labels.noResultsTitle}
    size="small"
    description={labels.noResultsDescription}
    media={<EmptyStateNoResultIllustration />}
  />
);

export const TableLoadingOverlay = () => (
  <ArdoqLoaderComponent
    loaderType="spinner"
    loaderColor={LoaderColor.BRAND}
    size={LoaderSize.SMALL}
  />
);
